export default "__VITE_ASSET__CYomyI8x__"